module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    class: {
      showHeaderMobile123: _vm.currentRoute.name === 'SignUp' || _vm.currentRoute.name === 'Gift' || _vm.currentRoute.name === 'Gifts' || _vm.currentRoute.name === 'Redeem,' || _vm.currentRoute.name === 'Event' || _vm.currentRoute.name === 'AccentureCharlotte' || _vm.currentRoute.name === 'CorporationGifting' || _vm.currentRoute.name === 'CorporationGiftingComcast' || _vm.currentRoute.name === 'CorporationReferral'
    },
    style: ({
      backgroundColor: _vm.getCorpHeaderColor
    } + ' !important')
  }, [(_vm.currentRoute.name !== 'Feedback' && _vm.currentRoute.name !== 'Maintainance' && _vm.isUserLoggedIn) ? _c('a', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    staticClass: "fixed-fab-btn logged",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.headerMenusClick('/contactus')
      }
    }
  }, [_vm._v("\n            Tell us what you think\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.isNativeApp && (_vm.user && _vm.user.corporation == null) && _vm.showGiftingLinks) ? _c('span', [(_vm.currentRoute.name !== 'Gift' && _vm.currentRoute.name !== 'Gifts' && _vm.currentRoute.name !== 'Redeem,' && _vm.currentRoute.name !== 'SignUp' && _vm.currentRoute.name !== 'AccentureCharlotte' && _vm.currentRoute.name !== 'TrialExpiry' && _vm.currentRoute.name !== 'InterestList' && _vm.currentRoute.name !== 'CorporationGifting' && _vm.currentRoute.name !== 'CorporationGiftingComcast' && _vm.currentRoute.name !== 'CorporationReferral' && _vm.currentRoute.name !== 'Maintainance') ? _c('a', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    staticClass: "giftslink",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "aria-label": "Gifts",
      "title": "Gifts"
    },
    on: {
      "click": function($event) {
        return _vm.headerMenusClick('/gifts')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-gift",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.getGiftingText))])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.isNativeApp && (_vm.user && _vm.user.corporation == null) && !_vm.showGiftingLinks && _vm.getAuthLeftTopBannerMessage && _vm.currentRoute.path != _vm.getAuthLeftTopBannerUrl) ? _c('div', {
    staticClass: "cust-corp-banner"
  }, [(!_vm.getAuthLeftTopBannerUrl || _vm.getAuthLeftTopBannerUrl.length < 3) ? _c('span', [_vm._v("\n                " + _vm._s(_vm.getAuthLeftTopBannerMessage) + "\n            ")]) : _c('span', [(_vm.getAuthLeftTopBannerUrl) ? _c('a', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": _vm.getAuthLeftTopBannerUrl
    },
    on: {
      "click": function($event) {
        return _vm.corpBannerRedirect(_vm.getAuthLeftTopBannerUrl)
      }
    }
  }, [_vm._v(_vm._s(_vm.getAuthLeftTopBannerMessage))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (!_vm.isNativeApp && (_vm.user && _vm.user.corporation && _vm.user.corporation.giftIconState === 1) && _vm.showGiftingLinks) ? _c('span', [(_vm.currentRoute.name !== 'Gift' && _vm.currentRoute.name !== 'Gifts' && _vm.currentRoute.name !== 'Redeem,' && _vm.currentRoute.name !== 'SignUp' && _vm.currentRoute.name !== 'AccentureCharlotte' && _vm.currentRoute.name !== 'TrialExpiry' && _vm.currentRoute.name !== 'InterestList' && _vm.currentRoute.name !== 'CorporationGifting' && _vm.currentRoute.name !== 'CorporationGiftingComcast' && _vm.currentRoute.name !== 'CorporationReferral' && _vm.currentRoute.name !== 'Maintainance') ? _c('a', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    staticClass: "giftslink",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "aria-label": "Gifts",
      "title": "Gifts"
    },
    on: {
      "click": function($event) {
        return _vm.headerMenusClick('/gifts')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-gift",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.getGiftingText))])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.isNativeApp && (_vm.user && _vm.user.corporation && _vm.user.corporation.giftIconState === 2) && _vm.showGiftingLinks) ? _c('span') : _vm._e(), _vm._v(" "), (!_vm.isNativeApp && (_vm.user && _vm.user.corporation && _vm.user.corporation.giftIconState === 3)) ? _c('div', {
    staticClass: "cust-corp-banner"
  }, [(!_vm.user.corporation.giftIconUrl) ? _c('span', [_vm._v("\n                " + _vm._s(_vm.user.corporation.giftIconMessage) + "\n            ")]) : _c('span', [(_vm.user.corporation.giftIconMessage) ? _c('a', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": _vm.user.corporation.giftIconMessage
    },
    on: {
      "click": function($event) {
        return _vm.corpBannerRedirect(_vm.user.corporation.giftIconUrl)
      }
    }
  }, [_vm._v(_vm._s(_vm.user.corporation.giftIconMessage))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "logo"
  }, [_c('a', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.logoClickRedirect
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/logo.svg"),
      "alt": "TONE LOGO"
    }
  })])]), _vm._v(" "), (_vm.getCustomUnauthBannerStatus && (_vm.currentRoute.name === 'UnAuth' && _vm.currentRoute.name !== 'Maintainance') && !_vm.hideBanner) ? _c('div', {
    staticClass: "notificationtext"
  }, [_c('a', {
    attrs: {
      "href": _vm.getCustomUnauthBannerLink
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(_vm.getCustomUnauthBannerLink)
      }
    }
  }, [_vm._v(_vm._s(_vm.getCustomUnauthBannerText))]), _vm._v(" "), _c('a', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    staticClass: "close",
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        _vm.hideBanner = true
      }
    }
  }, [_vm._v("x")])]) : _vm._e(), _vm._v(" "), (_vm.getBannerEvent > 0 && !_vm.getCustomUnauthBannerStatus && (_vm.currentRoute.name === 'UnAuth' && _vm.currentRoute.name !== 'Maintainance') && !_vm.hideBanner) ? _c('div', {
    staticClass: "notificationtext"
  }, [_c('a', {
    attrs: {
      "href": '/event'
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push('/event')
      }
    }
  }, [_vm._v(_vm._s(_vm.eventDescription))]), _vm._v(" "), _c('a', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    staticClass: "close",
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        _vm.hideBanner = true
      }
    }
  }, [_vm._v("x")])]) : _vm._e(), _vm._v(" "), (_vm.getBannerEvent > 0 && (_vm.currentRoute.name !== 'UnAuth' && _vm.currentRoute.name !== 'Event' && _vm.currentRoute.name !== 'Rules' && _vm.currentRoute.name !== 'Events' && _vm.currentRoute.name !== 'Talk' && _vm.currentRoute.name !== 'LiveEvent') && _vm.user && _vm.user.corporation == null) ? _c('div', {
    staticClass: "notificationtext"
  }, [(_vm.currentRoute.name !== 'Maintainance') ? _c('a', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": _vm.JoinEventOrRedirect
    }
  }, [_vm._v(_vm._s(_vm.authEventDescription))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.user && _vm.user.corporation && _vm.user.corporation.corporationId > 0 && _vm.user.corporation.enableCorporatePage === 1) ? _c('span', [(_vm.getBannerEvent > 0 && (_vm.currentRoute.name !== 'UnAuth' && _vm.currentRoute.name !== 'Event' && _vm.currentRoute.name !== 'Rules' && _vm.currentRoute.name !== 'Events' && _vm.currentRoute.name !== 'Talk' && _vm.currentRoute.name !== 'LiveEvent') && (_vm.user && _vm.user.corporation && _vm.user.corporation.corporationId > 0 && _vm.user.corporation.enableCorporatePage === 0)) ? _c('div', {
    staticClass: "notificationtext"
  }, [(_vm.currentRoute.name !== 'Maintainance') ? _c('a', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": _vm.JoinEventOrRedirect
    }
  }, [_vm._v(_vm._s(_vm.authEventDescription))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.getBannerEvent > 0 && (_vm.currentRoute.name !== 'UnAuth' && _vm.currentRoute.name !== 'Event' && _vm.currentRoute.name !== 'Rules' && _vm.currentRoute.name !== 'Events' && _vm.currentRoute.name !== 'Talk' && _vm.currentRoute.name !== 'LiveEvent') && (_vm.user && _vm.user.corporation && _vm.user.corporation.corporationId > 0 && _vm.user.corporation.enableCorporatePage === 1 && _vm.user.corporation.bnrLinkState === 1)) ? _c('div', {
    staticClass: "notificationtext"
  }, [(_vm.currentRoute.name !== 'Maintainance') ? _c('a', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": _vm.JoinEventOrRedirect
    }
  }, [_vm._v(_vm._s(_vm.authEventDescription))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.getBannerEvent > 0 && (_vm.currentRoute.name !== 'UnAuth' && _vm.currentRoute.name !== 'Event' && _vm.currentRoute.name !== 'Rules' && _vm.currentRoute.name !== 'Events' && _vm.currentRoute.name !== 'Talk' && _vm.currentRoute.name !== 'LiveEvent') && (_vm.user && _vm.user.corporation && _vm.user.corporation.corporationId > 0 && _vm.user.corporation.enableCorporatePage === 1 && _vm.user.corporation.bnrLinkState === 2)) ? _c('div', {
    staticClass: "notificationtext"
  }, [(_vm.currentRoute.name !== 'Maintainance') ? _c('a', {
    attrs: {
      "href": '/corporation/mycommunity'
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push('/corporation/mycommunity')
      }
    }
  }, [_vm._v(_vm._s(_vm.user.corporation.corpEvent.authBannerText))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.getBannerEvent > 0 && (_vm.currentRoute.name !== 'UnAuth' && _vm.currentRoute.path != _vm.user.corporation.bnrCustomMsgUrl && (_vm.user && _vm.user.corporation && _vm.user.corporation.corporationId > 0 && _vm.user.corporation.enableCorporatePage === 1 && _vm.user.corporation.bnrLinkState === 3))) ? _c('div', {
    staticClass: "notificationtext"
  }, [(_vm.currentRoute.name !== 'Maintainance') ? _c('a', {
    attrs: {
      "href": _vm.user.corporation.bnrCustomMsgUrl
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(_vm.user.corporation.bnrCustomMsgUrl)
      }
    }
  }, [_vm._v(_vm._s(_vm.user.corporation.bnrCustomMsg))]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isNav),
      expression: "!isNav"
    }],
    staticClass: "nav-container"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('nav', {
    staticClass: "navbar",
    class: [_vm.isUserLoggedIn ? 'static-min-height' : 'default-min-height'],
    style: ([_vm.isMobile ? {
      'backgroundColor': _vm.getCorpHeaderColor
    } : {}])
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [(!_vm.isNativeAppNavigation) ? _c('button', {
    staticClass: "pull-left navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#header-navbar",
      "aria-controls": "header-navbar",
      "aria-expanded": "false"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })]) : _vm._e(), _vm._v(" "), _c('svg', {
    staticClass: "mobile-version",
    attrs: {
      "width": "172px",
      "height": "69px",
      "viewBox": "0 0 172 69",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Design-Round-5",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "01_Tone_Home_1200_PINK",
      "transform": "translate(-514.000000, -33.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Main-Nav"
    }
  }, [_c('g', {
    attrs: {
      "id": "Mast-Head"
    }
  }, [_c('a', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    attrs: {
      "aria-label": "TONE home"
    },
    on: {
      "click": _vm.logoClickRedirect
    }
  }, [_c('image', {
    attrs: {
      "id": "Logo",
      "x": "514",
      "y": "33",
      "width": "171.952381",
      "height": "69",
      "xlink:href": "data:image/png;base64,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"
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mobile-loginLogoutholder"
  }, [(!_vm.isUserLoggedIn && !_vm.getCorporateGiftingCode) ? _c('a', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    staticClass: "btn btn-link",
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('login')
      }
    }
  }, [_vm._v("Sign In\n                                        ")]) : _vm._e(), _vm._v(" "), (!_vm.isUserLoggedIn && !_vm.isNativeApp) ? _c('a', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    staticClass: "btn btn-link",
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        _vm.getCorporateClient ? _vm.redeemGiftcodeMobile() : _vm.$router.push('/signup')
      }
    }
  }, [(_vm.getCorporateGiftingCode && _vm.getCorporateClient) ? _c('span', [_vm._v("Redeem")]) : _c('span', [_vm._v("\n                                                Join\n                                                ")])]) : _vm._e()]), _vm._v(" "), (!_vm.isNativeAppNavigation && (_vm.currentRoute.name !== 'B2b')) ? _c('a', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    staticClass: "collapsed nav-icon navbar-toggle search-icon",
    attrs: {
      "aria-label": "Search",
      "data-toggle": "collapse",
      "aria-expanded": "false",
      "aria-controls": "nav-search"
    },
    on: {
      "click": function($event) {
        return _vm.searchClick()
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "navbar-collapse collapse",
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "id": "header-navbar"
    }
  }, [_c('ul', {
    staticClass: "nav application-icons navbar-nav navbar-left margin-left"
  }, [(!_vm.isNativeAppNavigation) ? _c('li', [(_vm.isUserLoggedIn && _vm.user.minVidReqdWork) ? _c('router-link', {
    staticClass: "logged",
    attrs: {
      "to": {
        path: '/work'
      }
    }
  }, [_c('i', {
    staticClass: "nav-icon career-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('p', [_vm._v("WORK")])]) : _vm._e(), _vm._v(" "), (!_vm.isUserLoggedIn) ? _c('router-link', {
    staticClass: "logged",
    attrs: {
      "to": {
        path: '/content/work'
      }
    }
  }, [_c('i', {
    staticClass: "nav-icon career-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('p', [_vm._v("WORK")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.isNativeAppNavigation) ? _c('li', [(_vm.isUserLoggedIn && _vm.user.minVidReqdLife) ? _c('router-link', {
    staticClass: "logged",
    attrs: {
      "to": {
        path: '/life'
      }
    }
  }, [_c('i', {
    staticClass: "nav-icon inspiration-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('p', [_vm._v("LIFE")])]) : _vm._e(), _vm._v(" "), (!_vm.isUserLoggedIn) ? _c('router-link', {
    staticClass: "logged",
    attrs: {
      "to": {
        path: '/content/life'
      }
    }
  }, [_c('i', {
    staticClass: "nav-icon inspiration-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('p', [_vm._v("LIFE")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.isNativeAppNavigation) ? _c('li', [(_vm.isUserLoggedIn && _vm.user.minVidReqdMindBody) ? _c('router-link', {
    staticClass: "logged",
    attrs: {
      "to": {
        path: '/mindbody'
      }
    }
  }, [_c('i', {
    staticClass: "nav-icon mind-body-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('p', [_vm._v("MIND BODY")])]) : _vm._e(), _vm._v(" "), (!_vm.isUserLoggedIn) ? _c('router-link', {
    staticClass: "logged",
    attrs: {
      "to": {
        path: '/content/mindbody'
      }
    }
  }, [_c('i', {
    staticClass: "nav-icon mind-body-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('p', [_vm._v("MIND BODY")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.isNativeAppNavigation) ? _c('li', [(_vm.isUserLoggedIn && _vm.user.minVidReqdMoney) ? _c('router-link', {
    staticClass: "logged",
    attrs: {
      "to": {
        path: '/money'
      }
    }
  }, [_c('i', {
    staticClass: "nav-icon money-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('p', [_vm._v("MONEY")])]) : _vm._e(), _vm._v(" "), (!_vm.isUserLoggedIn) ? _c('router-link', {
    staticClass: "logged",
    attrs: {
      "to": {
        path: '/content/money'
      }
    }
  }, [_c('i', {
    staticClass: "nav-icon money-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('p', [_vm._v("MONEY")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.isNativeAppNavigation) ? _c('li', [(_vm.isUserLoggedIn) ? _c('router-link', {
    staticClass: "logged",
    attrs: {
      "to": {
        path: '/events'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar fa-2x",
    staticStyle: {
      "font-size": "22px",
      "margin": "0 0 8px",
      "color": "#8a8a8a"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('p', [_vm._v("EVENTS")])]) : _vm._e(), _vm._v(" "), (!_vm.isUserLoggedIn) ? _c('router-link', {
    staticClass: "logged",
    attrs: {
      "to": {
        path: '/newevents'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar fa-2x",
    staticStyle: {
      "font-size": "22px",
      "margin": "0 0 8px",
      "color": "#8a8a8a"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('p', [_vm._v("EVENTS")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.isNativeAppNavigation) ? _c('li', [_vm._m(0)]) : _vm._e(), _vm._v(" "), (!_vm.isNativeAppNavigation) ? _c('li', [(_vm.isUserLoggedIn) ? _c('router-link', {
    staticClass: "logged",
    attrs: {
      "to": {
        path: '/profile/playlist'
      }
    }
  }, [_c('img', {
    staticClass: "playlistsimg",
    attrs: {
      "src": require("../../assets/playlist-icon-b.png"),
      "alt": "TONE PLAYLISTS"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "playlistswhite",
    attrs: {
      "src": require("../../assets/playlist-icon-w.png"),
      "alt": "TONE PLAYLISTS"
    }
  }), _vm._v(" "), _c('p', [_vm._v("PLAYLISTS")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.isNativeAppNavigation) ? _c('li', [_c('router-link', {
    staticClass: "logged",
    attrs: {
      "to": {
        path: '/experts'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user-o fa-2x",
    staticStyle: {
      "font-size": "22px",
      "margin": "0 0 8px",
      "color": "#8a8a8a"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('p', [_vm._v("EXPERTS")])])], 1) : _vm._e(), _vm._v(" "), (!_vm.isNativeAppNavigation) ? _c('li', [_c('router-link', {
    staticClass: "logged",
    attrs: {
      "to": {
        path: '/resources'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-newspaper-o fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('p', [_vm._v("IN THE NEWS")])])], 1) : _vm._e(), _vm._v(" "), (!_vm.isNativeAppNavigation) ? _c('li', [(!_vm.user || (_vm.user && !_vm.user.corporation) || (_vm.user && _vm.user.corporation && _vm.user.corporation.enableCorporatePage === 0)) ? _c('router-link', {
    staticClass: "logged",
    attrs: {
      "to": {
        path: '/b2b'
      }
    }
  }, [_c('img', {
    staticClass: "businessimg",
    attrs: {
      "src": require("../../assets/business_icon_black.png"),
      "alt": "TONE B2B"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "businessimgwhite",
    attrs: {
      "src": require("../../assets/business-icon-white.png"),
      "alt": "TONE B2B"
    }
  }), _vm._v(" "), _c('p', [_vm._v("FOR BUSINESS")])]) : _vm._e(), _vm._v(" "), (_vm.user && (_vm.user.corporation && _vm.user.corporation.enableCorporatePage === 1)) ? _c('router-link', {
    staticClass: "logged",
    attrs: {
      "to": {
        path: '/corporation/mycommunity'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-suitcase fa-2x",
    staticStyle: {
      "font-size": "22px",
      "margin": "0 0 8px",
      "color": "#8a8a8a"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('p', [_vm._v("MY COMPANY")])]) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav navbar-right",
    class: [_vm.isUserLoggedIn ? 'margin-default' : 'margin-minimum']
  }, [(!_vm.isNativeAppNavigation && _vm.currentRoute.name !== 'B2b') ? _c('li', {
    staticClass: "mid-icons mobile-responsive-hide"
  }, [_c('router-link', {
    staticClass: "logged",
    attrs: {
      "aria-label": "Search",
      "to": {
        path: '/search'
      }
    }
  }, [_c('i', {
    staticClass: "nav-icon search-icon",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1) : _vm._e(), _vm._v(" "), (!_vm.isUserLoggedIn) ? _c('li', {
    staticClass: "mid-icons login-btn"
  }, [(!_vm.isNativeApp) ? _c('a', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    staticClass: "btn btn-link",
    style: ({
      'border-width': '0px !important',
      'border-style': 'solid !important',
      'border-color': this.getCorpButtonColor + ' !important',
      'color': '#FFFFFF'
    }),
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        _vm.getCorporateGiftInfo ? _vm.redeemGiftcode() : _vm.$router.push('/signup')
      }
    }
  }, [(_vm.getCorporateGiftingCode && _vm.getCorporateClient && _vm.getCorporateGiftInfo) ? _c('span', [_vm._v(_vm._s(_vm.getCorporateGiftInfo.button_label_01))]) : _c('span', [_vm._v("Join")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.isUserLoggedIn && !_vm.getCorporateGiftingCode) ? _c('li', {
    staticClass: "mid-icons login-btn"
  }, [_c('a', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    staticClass: "btn btn-link",
    style: ({
      'border-width': '0px !important',
      'border-style': 'solid !important',
      'border-color': '#45BCA9' + ' !important',
      'color': '#FFFFFF'
    }),
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('login')
      }
    }
  }, [_vm._v("\n                                                Sign In\n                                            ")])]) : _vm._e(), _vm._v(" "), (!_vm.isUserLoggedIn && !_vm.getCorporateGiftingCode) ? _c('li', {
    staticClass: "mid-icons sign-up-button"
  }, [_c('a', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    staticClass: "btn btn-success btn-lg",
    on: {
      "click": _vm.directToSignup
    }
  }, [_vm._v("\n                                                Start Your Free Trial\n                                            ")])]) : _vm._e(), _vm._v(" "), (_vm.isUserLoggedIn) ? _c('li', {
    staticClass: "mid-icons login-btn"
  }, [_c('a', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    style: ([!_vm.isMobile ? {
      'border-width': '1px !important',
      'border-style': 'solid !important',
      'border-color': this.getCorpButtonColor + ' !important',
      'color': _vm.$a11yInkColor(_vm.getCorpHeadingColor) + ' !important'
    } : {
      'border': '1px solid' + _vm.getCorpHeaderColor + ' !important',
      'color': _vm.getCorpHeadingColor,
      'backgroundColor': '#fff'
    }]),
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Logout")])]) : _vm._e(), _vm._v(" "), (_vm.isUserLoggedIn) ? _c('li', {
    staticClass: "userProfile"
  }, [(_vm.isUserLoggedIn.picture) ? _c('span', [_c('a', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    staticClass: "logged",
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.gotoProfile()
      }
    }
  }, [(_vm.user && _vm.user.corporation && _vm.user.corporation.showShoeMotif === 2) ? _c('span', [_c('img', {
    staticClass: "img-responsive img-circle",
    attrs: {
      "src": "https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-brd.png",
      "alt": "USER PROFILE"
    }
  })]) : _c('span', [_c('img', {
    staticClass: "img-responsive img-circle",
    attrs: {
      "src": _vm.isUserLoggedIn.picture,
      "alt": "USER SHOE"
    }
  })]), _vm._v(" "), (_vm.user.firstName) ? _c('span', {
    staticClass: "usernamelimit"
  }, [_vm._v(_vm._s(_vm.user.firstName.toLowerCase()))]) : _vm._e()])]) : _c('span', [_c('router-link', {
    staticClass: "logged",
    attrs: {
      "to": {
        path: '/profile'
      }
    }
  }, [_c('img', {
    staticClass: "img-responsive img-circle",
    attrs: {
      "src": "http://placekitten.com/g/200/200",
      "alt": "USER PROFILE"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "usernamelimit"
  }, [_vm._v(_vm._s(_vm.user.firstName.toLowerCase()))])])], 1)]) : _vm._e()]), _vm._v(" "), (!_vm.user) ? _c('div', {
    staticClass: "text-center unauth-links"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.startMsgBoard && _vm.msgDuration > 10 && _vm.msgBoard && _vm.user && (_vm.currentRoute.name !== 'TrialExpiry' || _vm.currentRoute.name !== 'Rules' || _vm.currentRoute.name !== 'LiveEvent' || _vm.currentRoute.name !== 'Talk')) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "alert alert-info text-center alertmsg"
  }, [(_vm.msgBoard[0].destinationURL && (_vm.msgBoard[0].destinationURL.indexOf('http') > -1 || _vm.msgBoard[0].destinationURL.indexOf('/') === 0)) ? _c('span', [_c('a', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.messageBoardRedirect(_vm.msgBoard[0])
      }
    }
  }, [_vm._v(_vm._s(_vm.msgBoard[0].bannerMessage))])]) : _c('span', [_vm._v("\n                        " + _vm._s(_vm.msgBoard[0].bannerMessage) + "\n                    ")]), _vm._v(" "), _c('a', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    staticClass: "close",
    attrs: {
      "aria-label": "close",
      "title": "close"
    },
    on: {
      "click": function($event) {
        return _vm.closeBanner()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), (_vm.showModal) ? _c('modal', {
    staticClass: "loginModal",
    attrs: {
      "effect": "zoom",
      "value": _vm.showModal,
      "width": "400"
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelModal()
      }
    }
  }, [_c('div', {
    staticClass: "loginHeaderModal",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('a', [_c('img', {
    attrs: {
      "src": require("../../assets/logo.svg"),
      "alt": "LOGO"
    }
  })]), _vm._v(" "), _c('a', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.cancelModal()
      }
    }
  }, [_c('img', {
    staticClass: "watchVideoArrow",
    attrs: {
      "src": require("../../assets/watch-video-arrow.png"),
      "alt": "CLOSE"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "bodyContent"
  }, [(!_vm.isForget) ? _c('div', {
    staticClass: "login-modal"
  }, [_c('div', [_c('h2', [_vm._v("Sign In")])]), _vm._v(" "), _c('div', {
    staticClass: "form"
  }, [_c('form', {
    attrs: {
      "id": "login_form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "padding-minus"
  }, [_c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "label": "Email Address",
      "autocomplete": "username",
      "id": "login_email",
      "type": "email",
      "error": "Email Address",
      "placeholder": "Email Address",
      "required": "",
      "icon": ""
    },
    model: {
      value: (_vm.info.email),
      callback: function($$v) {
        _vm.$set(_vm.info, "email", $$v)
      },
      expression: "info.email"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "label": "Password",
      "autocomplete": "current-password",
      "id": "login_password",
      "error": "Password",
      "type": "password",
      "placeholder": "Password",
      "required": "",
      "icon": ""
    },
    model: {
      value: (_vm.info.password),
      callback: function($$v) {
        _vm.$set(_vm.info, "password", $$v)
      },
      expression: "info.password"
    }
  })], 1), _vm._v(" "), _c('checkbox', {
    attrs: {
      "value": "isChecked",
      "type": "primary"
    },
    model: {
      value: (_vm.isChecked),
      callback: function($$v) {
        _vm.isChecked = $$v
      },
      expression: "isChecked"
    }
  }, [_vm._v("\n                                    Remember me\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "gradient-tone-header btn formButton btn-transparent",
    attrs: {
      "disabled": _vm.spinner,
      "id": "login_button"
    }
  }, [_vm._v("\n                                        Sign In\n                                    ")]), _vm._v(" "), (_vm.spinner) ? _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.spinner),
      callback: function($$v) {
        _vm.spinner = $$v
      },
      expression: "spinner"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('a', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    staticClass: "forgotPassword",
    attrs: {
      "href": "javascript:",
      "id": "login_lnkforgotpassword"
    },
    on: {
      "click": function($event) {
        _vm.isForget = !_vm.isForget
      }
    }
  }, [_c('strong', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("Forget your password ?")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    staticClass: "forgotPassword",
    attrs: {
      "href": "javascript:",
      "id": "login_redirectsingup"
    },
    on: {
      "click": function($event) {
        return _vm.redirectSignup()
      }
    }
  }, [_c('strong', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("Don't have an account? Subscribe here!")])])])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.isForget) ? _c('div', {
    staticClass: "forget-password-modal"
  }, [_c('div', [_c('h2', {
    staticClass: "forgot-heading"
  }, [_vm._v("\n                                Forgot your password?\n                            ")]), _vm._v(" "), _c('p', [_vm._v("Enter your email address to reset your password. your may need")]), _vm._v(" "), _c('p', [_vm._v("to check your spam folder to unblock")]), _vm._v(" "), _c('p', [_vm._v("no-reply@tonenetworks.com.")])]), _vm._v(" "), _c('div', {
    staticClass: "form"
  }, [_c('form', {
    attrs: {
      "id": "forgot_password_form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmitForgetRequest.apply(null, arguments)
      }
    }
  }, [_c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "label": "Email Address",
      "autocomplete": "email",
      "id": "forgot_password_email",
      "type": "email",
      "error": "Email Address",
      "placeholder": "Email Address",
      "required": "",
      "icon": ""
    },
    model: {
      value: (_vm.forgetPassword.email),
      callback: function($$v) {
        _vm.$set(_vm.forgetPassword, "email", $$v)
      },
      expression: "forgetPassword.email"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn formButton",
    attrs: {
      "disabled": _vm.spinner,
      "id": "forgot_password_proceed"
    }
  }, [_vm._v("\n                                        Submit\n                                        "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.spinner),
      callback: function($$v) {
        _vm.spinner = $$v
      },
      expression: "spinner"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('a', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    staticClass: "forgotPassword",
    attrs: {
      "href": "javascript:",
      "id": "login_lnkbacktologin"
    },
    on: {
      "click": function($event) {
        _vm.isForget = !_vm.isForget
      }
    }
  }, [_c('strong', [_vm._v("Back to Sign In")])])])], 1)])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })]) : _vm._e(), _vm._v(" "), (_vm.showExpiryModal) ? _c('modal', {
    staticClass: "expiredmodal",
    attrs: {
      "value": _vm.showExpiryModal,
      "effect": "zoom"
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelExpiryModal()
      }
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/coloredlogotone.png"),
      "alt": "LOGO"
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    staticClass: "close",
    attrs: {
      "aria-label": "Close",
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.cancelExpiryModal()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('h2', [_vm._v("We don't want to lose you!")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Your credit card on file is expiring in " + _vm._s(_vm.getCardExpiryDays) + " "), (_vm.getCardExpiryDays > 1) ? _c('span', [_vm._v("days.")]) : _c('span', [_vm._v("day.")]), _vm._v(" Help us keep your information up to date.")])]), _vm._v(" "), _c('div', {
    staticClass: "text-center small"
  }, [_c('button', {
    staticClass: "btn formButton btn-transparent",
    on: {
      "click": function($event) {
        _vm.cancelExpiryModal();
        _vm.$router.push('/profile')
      }
    }
  }, [_vm._v("\n                        Update Payment Info\n                    ")]), _c('br'), _vm._v(" "), _c('a', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.cancelExpiryModal()
      }
    }
  }, [_vm._v("Not now, I'll update later")]), _c('br'), _vm._v("\n                    If you have any questions please contact us at "), _c('a', {
    attrs: {
      "href": "mailto:feedback@tonenetworks.com"
    }
  }, [_vm._v("feedback@tonenetworks.com")]), _c('br'), _vm._v("\n                    For more information on our Terms of Services, "), _c('a', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        _vm.cancelExpiryModal();
        _vm.$router.push('/terms')
      }
    }
  }, [_vm._v("click here")])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })]) : _vm._e(), _vm._v(" "), (_vm.showExpiredModal) ? _c('modal', {
    staticClass: "expiredmodal",
    attrs: {
      "escape-closes": false,
      "backdrop": false,
      "value": _vm.showExpiredModal,
      "effect": "zoom"
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelExpiredModal()
      }
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('img', {
    staticClass: "expiryModalImage",
    attrs: {
      "src": require("../../assets/coloredlogotone.png"),
      "alt": "LOGO"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('h2', [_vm._v("Whoops, your payment failed! ")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("We were unable to verify your payment method on file. Don't worry, we'll try your payment again over the next five days. To keep Tone Networks access, you may need to update your payment details.")])]), _vm._v(" "), _c('div', {
    staticClass: "text-center small"
  }, [_c('button', {
    staticClass: "btn formButton btn-transparent",
    on: {
      "click": function($event) {
        _vm.cancelExpiredModal();
        _vm.$router.push('/profile')
      }
    }
  }, [_vm._v("\n                        Update Payment Info\n                    ")]), _c('br'), _vm._v("\n                    If you have any questions please contact us at "), _c('a', {
    attrs: {
      "href": "mailto:feedback@tonenetworks.com"
    }
  }, [_vm._v("feedback@tonenetworks.com")]), _c('br'), _vm._v("\n                    For more information on our Terms of Services, "), _c('a', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        _vm.cancelExpiredModal();
        _vm.$router.push('/terms')
      }
    }
  }, [_vm._v("click here")])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "logged",
    attrs: {
      "href": "https://blog.tonenetworks.com/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-rss fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('p', [_vm._v("BLOG")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "aria-label": "TONE Networks on facebook (opens in a new window)",
      "href": "https://www.facebook.com/tonenetworks/",
      "target": "new"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook-square fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "aria-label": "TONE Networks on twitter (opens in a new window)",
      "href": "https://twitter.com/ToneNetworks",
      "target": "new"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter-square fa-2x",
    attrs: {
      "data-v-5cb853a2": "",
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "aria-label": "TONE Networks on instagram (opens in a new window)",
      "href": "https://www.instagram.com/tonenetworks/",
      "target": "new"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram fa-2x",
    attrs: {
      "data-v-5cb853a2": "",
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "aria-label": "TONE Networks on linkedin (opens in a new window)",
      "href": "https://www.linkedin.com/company/25037986/",
      "target": "new"
    }
  }, [_c('i', {
    staticClass: "fa fa-linkedin-square fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "aria-label": "TONE Networks on youtube (opens in a new window)",
      "href": "https://www.youtube.com/channel/UCarjWAb1SWrzKtoeNimOVJA/videos",
      "target": "new"
    }
  }, [_c('i', {
    staticClass: "fa fa-youtube-play fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7063ff53", module.exports)
  }
}


// WEBPACK FOOTER //
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7063ff53"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"search":"pk_test_6pRNASCoBOKtIshFeQd4XMUh","replace":"pk_test_SLHUyTkZmNS1OnLNdclgNldo"}!./~/string-replace-loader?{"search":"https:/www1.dev-tonenetworks.com","replace":"https:/www1.dev-tonenetworks.com"}!./~/string-replace-loader?{"search":"https:/s3.amazonaws.com/tone-assets/app/navigation","replace":"https:/s3.amazonaws.com/tone-assets/app/navigation"}!./~/string-replace-loader?{"search":"sandbox_2yn8x45w_k2v4j3d55x4gh6xz","replace":"production_6r7mxqgh_htw3nq9wp32w8h2x"}!./src/components/layout/Header.vue